module.exports = __webpack_public_path__ + "static/media/mac.231a1783.png";